import { getToken } from "lib/api";

// In production nginx routes /recording/media/ to the ASGI service (same host).
// In dev that service is on its own port.
const MEDIA_BASE = process.env.REACT_APP_RECORDING_HTTP_BASE || "";

// A liveness capture image (JPEG) for a LivenessSession (keyed by session id),
// served with the token in the query string since an <img> cannot set a header.
export function livenessImageUrl(sessionId, kind) {
  const token = getToken();
  const k = (kind === "full" || kind === "gesture") ? `&kind=${kind}` : "";
  return `${MEDIA_BASE}/recording/media/liveness/${sessionId}/?token=${encodeURIComponent(
    token || ""
  )}${k}`;
}

// The server-recorded liveness capture as a playable MP4 (remuxed on demand),
// served with the token in the query string like the images.
export function livenessVideoUrl(sessionId) {
  const token = getToken();
  return `${MEDIA_BASE}/recording/media/liveness/${sessionId}/video/?token=${encodeURIComponent(
    token || ""
  )}`;
}

// The exact image an AnalysisDebugEntry sent to the vision AI (Super Admin debug),
// served with the token in the query string like the other media.
export function debugImageUrl(entryId) {
  const token = getToken();
  return `${MEDIA_BASE}/recording/media/debug/${entryId}/?token=${encodeURIComponent(
    token || ""
  )}`;
}

// The immutable, signed PDF report for a verification. Token in the query string
// so a browser direct-download (window.open / anchor) works without a header.
// Served by the DRF backend under the admin API (not the media/ASGI host).
export function livenessReportUrl(sessionId) {
  const token = getToken();
  return `/liveness/api/sessions/${sessionId}/report/?token=${encodeURIComponent(
    token || ""
  )}`;
}
